import { 
    SET_IMAGE_FILE,
    SET_IMAGES_FILE,
    DELETE_IMAGE_ARRAY,
    CLEAR_IMAGE_SELECTED
} from '../types';

export const getImage = (imageUrl) => dispatch => {
    dispatch({
        type: SET_IMAGE_FILE,
        imageUrl: imageUrl
    })
}
export const getImages = (imageUrl) => dispatch => {
    dispatch({
        type: SET_IMAGES_FILE,
        imageUrl: imageUrl
    })
}
export const clearImageSelected = () => dispatch => {
    dispatch({
        type: CLEAR_IMAGE_SELECTED,
    })
}
export const delImageOnArr = (index) => dispatch => {
    dispatch({
        type: DELETE_IMAGE_ARRAY,
        index: index
    })
}